export enum SessionStorageEnum {
  CreatePageRouteQueryParams = 'createPageRouteQueryParams',
  SessionStorage = 'SESSION_STORAGE',
  UserEditingFlight = 'USER_EDITING_FLIGHTS'
}

export type SessionStorageEnumType = keyof typeof SessionStorageEnum;
